export default '/build/80463437.svg'